import ForcePasswordChange from "./ForcePasswordChange";
import { useLocation } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";
import { useMemo, useState } from "react";
import UIAlert from "../../_core/components/ui/UIAlert";
import PasswordResetDialog from "../components/PasswordResetDialog";
import CognitoSignIn from "../components/CognitoSignIn";

interface LocationState {
  isSsoRedirect?: boolean;
}

const Login = () => {
  const [isResetPasswordDialogOpen, setIsResetPasswordDialogOpen] = useState(false);
  const [username, setUsername] = useState("");
  const location = useLocation();
  const isInvite = location.pathname.includes("invite");
  const showBanner = useMemo(() => (location.state as LocationState)?.isSsoRedirect === true, [location.state]);

  const redirectAlert = useMemo(
    () => (
      <UIAlert severity="warning">
        Heads up! You came from our old login page. Save this new URL as your bookmark to avoid extra redirects.
      </UIAlert>
    ),
    [],
  );

  const handleRequirePasswordReset = (resetUsername: string) => {
    setUsername(resetUsername);
    setIsResetPasswordDialogOpen(true);
  };

  const renderContent = () => {
    if (isInvite) {
      return <ForcePasswordChange />;
    }

    return <CognitoSignIn onRequirePasswordReset={handleRequirePasswordReset} />;
  };

  return (
    <>
      <PasswordResetDialog
        open={isResetPasswordDialogOpen}
        username={username}
        onClose={() => setIsResetPasswordDialogOpen(false)}
      />
      <AuthLayout title="Login" banner={showBanner ? redirectAlert : null} data-testid="login-page">
        {renderContent()}
      </AuthLayout>
    </>
  );
};

export default Login;
